module.exports = __webpack_public_path__ + "static/media/11.Sugarcane Juice Machine Imported.eb99869e.jpg";